import { useLocation } from 'react-router-dom';

export function usePathnameSegments<T = string[]>(): T {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter((s) => !!s);
  return segments as T;
}
